import { supportedLocales } from '@trello/locale';
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { Icon, IconName } from 'app/common/components/controls';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';
import React from 'react';
import {
  useUpdateUserLocaleMutation,
  useLanguagePickerQuery,
} from '@trello/graphql/generated';

const noop = () => {};

export const LanguagePicker: React.FunctionComponent<{ memberId: string }> = ({
  memberId,
}) => {
  const { data, error } = useLanguagePickerQuery({ variables: { memberId } });
  const [updateUserLocale] = useUpdateUserLocaleMutation();
  const createClickHandler = (code: string) => async () => {
    await updateUserLocale({
      variables: { memberId, locale: code },
      optimisticResponse: {
        __typename: 'Mutation',
        updateUserLocale: {
          id: memberId,
          prefs: {
            locale: code,
            __typename: 'Member_Prefs',
          },
          __typename: 'Member',
        },
      },
    });

    window.location.reload();
  };

  if (error) {
    console.error(error);
  }

  const locale =
    data && data.member && data.member.prefs && data.member.prefs.locale;

  return (
    <PopoverMenu>
      {supportedLocales.map(({ code, name }) => {
        const isSelected = locale === code;

        let testId;

        switch (code) {
          case 'en-US':
            testId = HeaderTestIds.MemberMenuLanguageEn;
            break;
          case 'ja':
            testId = HeaderTestIds.MemberMenuLanguageJa;
            break;
          default:
            testId = undefined;
        }

        const clickHandler = isSelected ? noop : createClickHandler(code);

        return (
          <PopoverMenuButton key={code} onClick={clickHandler} testId={testId}>
            {name}
            {isSelected && <Icon name={IconName.Check} small />}
          </PopoverMenuButton>
        );
      })}
    </PopoverMenu>
  );
};
